/**
 * PUT with upload progress. fetch() can't report upload progress, XMLHttpRequest can. Storage must expose the ETag
 * header through CORS (infra/modules/r2 does).
 */
export function xhrPut(url: string, body: Blob, onProgress: (sent: number) => void, signal: AbortSignal): Promise<string> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const onAbort = () => xhr.abort();
    xhr.open("PUT", url);
    xhr.upload.onprogress = (e) => onProgress(e.loaded);
    xhr.onload = () => {
      signal.removeEventListener("abort", onAbort);
      const etag = xhr.getResponseHeader("ETag");
      if (xhr.status >= 200 && xhr.status < 300 && etag) resolve(etag);
      else reject(new Error(xhr.status >= 200 && xhr.status < 300 ? "Storage didn't return an ETag (check the bucket's CORS)" : `Upload part failed (${xhr.status})`));
    };
    xhr.onerror = () => { signal.removeEventListener("abort", onAbort); reject(new Error("Upload part failed (network)")); };
    xhr.onabort = () => { signal.removeEventListener("abort", onAbort); reject(new DOMException("Upload cancelled", "AbortError")); };
    signal.addEventListener("abort", onAbort, { once: true });
    xhr.send(body);
  });
}
